import { Storage, Drivers } from '@ionic/storage';
import cordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { Capacitor } from '@capacitor/core';
import logger from '@/logger';
import { cloneDeep } from 'lodash';
import { SLOW_DL } from '@/constants';

export function keyFor(type) {
    return key => `${type}:${key}`;
}

const colors = Object.freeze({
    read: 'color: green',
    write: 'color: orange',
    delete: 'color: red',
    none: 'color: initial',
});

function impl() {
    const dl = new Storage({
        // eslint-disable-next-line no-underscore-dangle
        driverOrder: [cordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage],
    });

    let isReady = false;
    const ready = prepare();
    return {
        async get(key) {
            if (!isReady) await ready;
            if (SLOW_DL) await slow();
            const result = await dl.get(key);
            logger.groupCollapsed(`%c[dl get] %c${key}`, colors.read, colors.none);
            logger.log(result);
            logger.groupEnd();
            return result;
        },
        async set(key, value) {
            if (!isReady) await ready;
            value = cloneDeep(value);
            logger.groupCollapsed(`%c[dl set] %c${key}`, colors.write, colors.none);
            logger.log(value);
            logger.groupEnd();
            return dl.set(key, value);
        },
        async remove(key) {
            if (!isReady) await ready;
            logger.log(`%c[dl remove] %c${key}`, colors.delete, colors.none);
            return dl.remove(key);
        },
        async clear() {
            if (!isReady) await ready;
            logger.log('%c[dl clear]', colors.delete);
            return dl.clear();
        },
    };
	
    async function prepare() {
        if (Capacitor.getPlatform() !== 'web')
            await dl.defineDriver(cordovaSQLiteDriver);
		
        logger.log(`using ${dl.driver} for storage driver`);
        await dl.create();
        isReady = true;
    }
}

function slow() {
    return new Promise(resolve => setTimeout(resolve, 500 + Math.random() * 1000));
}

const dl = impl();
export default dl;